var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#93BDE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.035 31.734h2.035c1.68 0 2.653-1.039 2.653-2.828v-.008c0-1.77-.98-2.8-2.653-2.8H9.035v5.636zm.875-.754v-4.128h1.063c1.168 0 1.859.761 1.859 2.058v.008c0 1.309-.68 2.063-1.86 2.063H9.91zm7.402.891c1.63 0 2.63-1.148 2.63-2.953v-.008c0-1.808-1.008-2.95-2.63-2.95-1.617 0-2.632 1.138-2.632 2.95v.008c0 1.809.992 2.953 2.633 2.953zm0-.773c-1.085 0-1.738-.86-1.738-2.18v-.008c0-1.332.672-2.176 1.739-2.176 1.066 0 1.734.844 1.734 2.176v.008c0 1.32-.664 2.18-1.735 2.18zm6.13.773c1.257 0 2.175-.719 2.34-1.8v-.024h-.868l-.008.015c-.16.637-.718 1.036-1.465 1.036-1.015 0-1.648-.84-1.648-2.176v-.008c0-1.34.633-2.18 1.645-2.18.742 0 1.308.45 1.472 1.141v.012h.867l.004-.02c-.148-1.12-1.101-1.906-2.343-1.906-1.567 0-2.54 1.133-2.54 2.953v.008c0 1.816.977 2.95 2.543 2.95zm2.995-.137h.97l1.413-2.152h.032l1.406 2.152h1.023l-1.875-2.804v-.016l1.91-2.816h-.984l-1.398 2.183h-.04L27.5 26.098h-1.043l1.855 2.789v.011l-1.875 2.836z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.c6acc754e8456930bda5978e0351fbb4.svg";
export { ForwardRef as ReactComponent };